import { Agreement } from './../_models/agreement.model';

// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud/models/query-models/query-results.model';
// State
import { AgreementsState } from '../_reducers/agreement.reducers';
import * as fromAgreement from '../_reducers/agreement.reducers';
import { each } from 'lodash-es';

export const selectAgreementsState = createFeatureSelector<AgreementsState>('agreements');

export const selectAgreementById = (agreementId: number) =>
  createSelector(selectAgreementsState, (agreementsState) => agreementsState.entities[agreementId]);

export const selectAllAgreements = createSelector(
  selectAgreementsState,
  (agreementsState) => agreementsState.allAgreements,
);

export const selectAllCompanyAgreements = createSelector(
  selectAgreementsState,
  fromAgreement.selectAll,
);

export const selectAllAgreementsIds = createSelector(
  selectAgreementsState,
  fromAgreement.selectIds,
);

export const allAgreementsLoaded = createSelector(
  selectAgreementsState,
  (agreementsState) => agreementsState.isAllAgreementsLoaded,
);

export const selectAgreementsPageLoading = createSelector(
  selectAgreementsState,
  (agreementsState) => agreementsState.listLoading,
);

export const selectAgreementsActionLoading = createSelector(
  selectAgreementsState,
  (agreementsState) => agreementsState.actionsloading,
);

export const selectLastCreatedAgreementId = createSelector(
  selectAgreementsState,
  (agreementsState) => agreementsState.lastCreatedAgreementId,
);

export const selectAgreementsShowInitWaitingMessage = createSelector(
  selectAgreementsState,
  (agreementsState) => agreementsState.showInitWaitingMessage,
);

export const selectAgreementLatestSuccessfullAction = createSelector(
  selectAgreementsState,
  (agreementsState) => agreementsState.latestSuccessfullAction,
);

export const selectAgreementError = createSelector(
  selectAgreementsState,
  (agreementsState) => agreementsState.error,
);

export const selectQueryResult = createSelector(selectAgreementsState, (agreementsState) => {
  const items: Agreement[] = [];
  each(agreementsState.ids, (ele) => {
    const index: number = +ele;
    items.push(agreementsState.entities[index]);
  });
  return new QueryResultsModel(items, agreementsState.totalCount);
});
